import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import imageOne from '../../resource/meditate/internalRetreats/organiser/2.png'
import imageFive from '../../resource/meditate/internalRetreats/organiser/3.png'
import imageSix from '../../resource/meditate/internalRetreats/organiser/4.png'
import imageThree from '../../resource/meditate/internalRetreats/organiser/1.png'
import apiClient from "@/api/client";

const InternalRetreatOrganiser = () => {
  const navigate = useNavigate();
  const [organiserData, setOrganiserData] = useState([]);

  // API endpoint for fetching organiser registrations
  const endpoint = '/get-internal-retreat-organiser-registrations';

  useEffect(() => {
    // Fetch data using apiClient
    apiClient.get(endpoint)
      .then((response) => {
        const data = response.data;
        if (data && Array.isArray(data)) {
          setOrganiserData(data);
        } else if (data && Array.isArray(data.data)) {
          setOrganiserData(data.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching organiser data:', error);
      });
  }, []);

  const handleClick = (event) => {
    const pathMap = {
      organiserInstructions: '/organiserInstructions',
      OrgainserRegister: "/OrgainserRegister"
    }

    const path = event.currentTarget.id;
    const targetPath = pathMap[path]

    if (targetPath) {
      navigate(targetPath)
    }
  }

  // Helper function to get full name
  const getFullName = (first, last) => {
    if (!first && !last) return '';
    return `${first || ''} ${last || ''}`.trim();
  };

  // Helper function to find organiser for specific month and year
  const getOrganiserForMonth = (month, year) => {
    const monthNumber = new Date(`${month} 1, ${year}`).getMonth() + 1;
    
    return organiserData.find(organiser => {
      if (organiser.months) {
        // If months is stored as a number, check if it matches
        return parseInt(organiser.months) === monthNumber;
      }
      // You might also want to check other fields like preferred_month if your API structure is different
      return false;
    });
  };

  // Get current date and create months array starting from current month
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-based index
  
  const allMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  
  // Create array of months starting from current month for next 12 months
  const months = [];
  for (let i = 0; i < 12; i++) {
    const monthIndex = (currentMonth + i) % 12;
    const year = currentYear + Math.floor((currentMonth + i) / 12);
    months.push({
      name: allMonths[monthIndex],
      year: year,
      monthNumber: monthIndex + 1
    });
  }

  return (
    <div className="InternalRetreatOrganiser-page inside-pages">
      <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
      </div>

      <h1 className='font-main p-4 mt-4'>Internal Retreat Organiser</h1>

      <div className="p-4">
        <p className="h4 mt-5">Bhaddhake Vihari Monastery and Meditation Centre invites dedicated volunteers to assist in the organization and coordination of internal retreat events, ensuring the smooth running of these retreats. Volunteers will have the opportunity to take responsibility for the internal retreats during the month of their choice. The monastery will provide all essential guidelines and pertinent information related to the internal retreat for the selected month</p>
        <p className="h4 mt-5">We deeply appreciate your time, support, and participation in contributing to the success of the monastery's monthly programs.</p>
      </div>

      <table className='katina-req mt-6'>
        <thead>
          <tr>
            <th className='font-second'>Month</th>
            <th className='font-second'>Organiser Details</th>
          </tr>
        </thead>
        <tbody className='h4 text-center'>
          {months.map(monthObj => {
            const organiser = getOrganiserForMonth(monthObj.name, monthObj.year);
            
            return (
              <tr key={`${monthObj.year}-${monthObj.name}`}>
                <td>{monthObj.year} <br /> {monthObj.name}</td>
                <td>
                  {organiser ? (
                    <>
                      {getFullName(organiser.first_name, organiser.last_name)} <br />
                      {organiser.mobile_number || organiser.whatsapp_number}
                      {organiser.beginner && <><br /><small>(Beginner)</small></>}
                      {organiser.experienced_volunteer && <><br /><small>(Experienced)</small></>}
                    </>
                  ) : (
                    'Available'
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="btn-group2 mt-6">
        <img src={imageFive} alt="Right Top Image" width={300} onClick={handleClick} className="curser-pointer" id='OrgainserRegister' />
        <img src={imageSix} alt="Right Top Image" width={300} onClick={handleClick} className="curser-pointer" id='organiserInstructions' />
      </div>

      <div className="p-4 mt-6 text-center">
        <div className="mt-6 calander-box align-item-center">
          <div className="c-details text-left">
            <h2 className='intro-text'>Further More Details:</h2>
            <p className="font-p mt-4">Monastery: 035608 0918 / 0459 729 738</p>
            <p className="font-p">WhatsApp: 0422 069 359</p>
            <p className="font-p">E-mail: info@bvp.org.au</p>
          </div>
        </div>
      </div>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  )
}

export default InternalRetreatOrganiser